import { FamilyDetailMember } from "creso-core/types";
import { Badge, cn } from "web-design-system";

export function MemberAccessBadge({ member }: { member: FamilyDetailMember }) {
  const hasFullAccess = member.access_role === "FULL";
  const label = hasFullAccess ? "Full" : "Self";
  return (
    <Badge
      variant="custom"
      className={cn(
        hasFullAccess
          ? "bg-tag-violet text-tag-violet-foreground"
          : "bg-tag-blue text-tag-blue-foreground"
      )}
    >
      {label}
    </Badge>
  );
}
